import Vue from "vue";
import Vuex from "vuex";
import * as mqtt from "mqtt";
import axios from "axios";
//import { time } from 'console'

const getDefaultMqttUrl = () => {
  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  return `${protocol}://${window.location.host}/mqtt`;
};

const normalizeMqttUrl = (mqttUrl) => {
  const defaultMqttUrl = getDefaultMqttUrl();

  // ถ้าเว็บเปิดผ่าน HTTPS ให้บังคับใช้ WSS ผ่าน Nginx เท่านั้น
  if (window.location.protocol === "https:") {
    if (
      !mqttUrl ||
      mqttUrl.startsWith("ws://") ||
      mqttUrl.startsWith("http://") ||
      mqttUrl.includes(":8883") ||
      mqttUrl.includes(":9001")
    ) {
      return defaultMqttUrl;
    }

    // ถ้าเป็น wss:// แต่ไม่ใช่ /mqtt ก็ยังบังคับกลับมาใช้ path กลาง
    if (mqttUrl.startsWith("wss://") && !mqttUrl.includes("/mqtt")) {
      return defaultMqttUrl;
    }
  }

  return mqttUrl || defaultMqttUrl;
};

const getChannelNames = (channels = []) => {
  if (!Array.isArray(channels)) return [];

  return channels
    .map((item) => (typeof item === "string" ? item : item && item.channel))
    .filter((topic) => typeof topic === "string" && topic.trim() !== "");
};

const normalizeChannels = (channels = []) => {
  if (!Array.isArray(channels)) return [];

  return channels
    .map((item) => {
      const channel = typeof item === "string" ? item : item && item.channel;
      if (!channel) return null;

      return {
        ...(typeof item === "object" && item !== null ? item : {}),
        channel,
        payload: "",
      };
    })
    .filter(Boolean);
};

const syncDataWithCurrentChannels = (state) => {
  const validTopics = getChannelNames(state.channel);
  const validTopicSet = new Set(validTopics);
  const firstTopic = validTopics[0] || (state.user ? `${state.user.token}/` : "");

  // ล้าง payload/device ที่เคยรับมาจาก topic เก่า หรือ topic ของ user เดิม
  state.devices = Array.isArray(state.devices)
    ? state.devices.filter((device) => validTopicSet.has(device.topic))
    : [];

  // ถ้า widget เคยผูกกับ topic ที่ถูกลบแล้ว ให้ย้ายกลับไป topic ปัจจุบันตัวแรก
  if (Array.isArray(state.widgets)) {
    state.widgets.forEach((widget) => {
      if (!Object.prototype.hasOwnProperty.call(widget, "topic")) return;
      if (widget.deviceType === "control") return;
      if (!widget.topic || validTopicSet.has(widget.topic)) return;

      widget.topic = firstTopic;
      widget.payload = "";
      widget.timestamp = null;
    });
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    channel: [],
    client: null,
    mqttUrl: getDefaultMqttUrl(),
    serverUrl: `https://bcallcenter.com/api/`,
    //option: {username: 'guest' , password: 'guest'},
    devices: [], // {topic: xxx, payload:yyy ,timestamp:zzz}
    widgets: [],
    pages: [],
    pageId: 0,
    widgettype: [
      { name: "ToggleSwitch", icon: "mdi-toggle-switch", deviceType: "string" },
      { name: "Step", icon: "mdi-counter", deviceType: "string" },
      {
        name: "SilderHorizontal",
        icon: "mdi-ray-vertex",
        deviceType: "string",
      },
      {
        name: "TextInput",
        icon: "mdi-message-text-fast-outline",
        deviceType: "string",
      },
      { name: "TimeInput", icon: "mdi-timer", deviceType: "string" },
      { name: "Lamp", icon: "mdi-lightbulb-outline", deviceType: "string" },
      { name: "ValueDisplay", icon: "mdi-numeric", deviceType: "string" },
      { name: "Gauge", icon: "mdi-gauge", deviceType: "string" },
      { name: "Chart", icon: "mdi-chart-areaspline", deviceType: "string" },
      // { name: "Chart_2", icon: "mdi-chart-areaspline", deviceType: "object" },
    ],
    style: { backgroundColor: "#ffffff" },
    edit: false,
    deleteMode: false,
    addMode: false,
    webtype: "",
  },
  mutations: {
    saveChannels(state, channels) {
      state.channel = normalizeChannels(channels);
      syncDataWithCurrentChannels(state);
    },

    saveDevices(state, data) {
      var topic = data.topic;
      var payload = data.payload.toString("utf-8");
      var timestamp = new Date().toISOString();
      const validTopics = getChannelNames(state.channel);

      // รับ payload เฉพาะ topic ที่มีอยู่ใน Token ปัจจุบันเท่านั้น
      if (validTopics.length > 0 && !validTopics.includes(topic)) {
        return;
      }

      if (state.devices.length > 0) {
        var topicExists = state.devices.filter((f) => f.topic == topic);
        if (topicExists.length > 0) {
          topicExists[0].payload = payload;
          topicExists[0].timestamp = timestamp;
          topicExists[0].type = "string";
        } else {
          state.devices.push({
            topic: topic,
            payload: payload,
            timestamp: timestamp,
            type: "string",
          });
        }
        state.widgets
          .filter((f) => f.topic == topic)
          .forEach((w) => {
            w.payload = payload;
            w.topic = topic;
            w.timestamp = timestamp;
          });
        //state.pages.forEach((wg) => {
        //  wg.BCDBWidgets.filter((f) => f.topic == topic).forEach((w) => {
        //    w.payload = payload;
        //    w.topic = topic;
        //    w.timestamp = timestamp;
        //  });
        //});
      } else {
        state.devices.push({
          topic: topic,
          payload: payload,
          timestamp: timestamp,
          type: "string",
        });
      }

      //this.dispatch("doCheckRuleEngine")
    },
  },
  actions: {
    async fetchChannels({ state, commit }, token) {
      const userToken = token || (state.user && state.user.token);
      if (!userToken) {
        commit("saveChannels", []);
        return [];
      }

      const response = await axios.get(
        `${state.serverUrl}channel/${encodeURIComponent(userToken)}`,
      );
      commit("saveChannels", response.data);
      return state.channel;
    },

    async doConnection({ state, commit }) {
      console.log("doConnection");
      //state.client = mqtt.connect(url.parse(state.mqttUrl), state.option)

      // Disconnect existing connection if it exists
      if (state.client) {
        state.client.end();
        state.client = null;
      }

      const safeMqttUrl = normalizeMqttUrl(state.mqttUrl);

      console.log("MQTT URL before:", state.mqttUrl);
      console.log("MQTT URL safe:", safeMqttUrl);

      state.mqttUrl = safeMqttUrl;
      state.client = mqtt.connect(safeMqttUrl);

      state.client.on("connect", () => {
        console.log("doConnection", "connected", state.user.token);
        for (let j = 0; j < state.channel.length; j++) {
          state.client.subscribe(state.channel[j].channel);
          state.client.publish(
            state.user.token + "/Sync",
            state.channel[j].channel,
          );
        }
      });

      state.client.on("message", (topic, payload) => {
        console.log(
          "doConnection",
          "massage",
          "topic",
          topic,
          "payload",
          payload.toString("utf-8"),
        );

        commit("saveDevices", { topic: topic, payload: payload });
      });
    },
    async doPublish({ state, dispatch }, data) {
      var topic = data.topic;
      var payload = data.payload;
      const validTopics = getChannelNames(state.channel);

      if (!topic || (validTopics.length > 0 && !validTopics.includes(topic))) {
        console.warn("MQTT publish blocked: topic is not in current token list", topic);
        return;
      }

      if (!state.client || !state.client.connected) {
        await dispatch("doConnection");
      }

      if (state.client) {
        state.client.publish(topic, payload);
      }
    },
    saveAll({ state }) {
      console.log(state.widgets);
      var data = {
        devices: state.devices.filter((device) =>
          getChannelNames(state.channel).includes(device.topic),
        ),
        widgets: state.widgets.filter((f) => f.show == true),
        //ruleEngine: state.ruleEngine,
        pages: state.pages,
        pageId: state.pageId,
        mqttUrl: normalizeMqttUrl(state.mqttUrl),
        style: state.style,
      };
      //console.log(data);
      //localStorage.setItem(state.user.token + "/data", JSON.stringify(data));
      localStorage.setItem("user", JSON.stringify(state.user));

      const url = state.serverUrl + "saveWidgets/" + state.user.token;
      axios
        .post(url, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          // Handle the response if needed
          //console.log(response.data);
        });

      state.edit = false;
    },
    isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUserAgent =
        /android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
          userAgent,
        );
      const isSmallScreen = window.innerWidth <= 900;
      return isMobileUserAgent || isSmallScreen;
    },
    async loadAll({ state, dispatch }) {
      var user = localStorage.getItem("user");
      if (user != null && user != "") {
        state.user = JSON.parse(user);
      }
      if (state.user != null) {
        console.log("loadAll", state.user);
        var SuccessLoad;
        await axios
          .get(state.serverUrl + "loadWidgets/" + state.user.token)
          .then((response) => {
            SuccessLoad = response.data;
          });

        if (SuccessLoad != undefined) {
          // ตรวจสอบประเภทอุปกรณ์ด้วยฟังก์ชัน isMobileDevice
          const isMobile = await dispatch("isMobileDevice");
          if (isMobile == true) {
            state.webtype = "Mobile";

            // เรียงตาม id ก่อน
            SuccessLoad.widgets = SuccessLoad.widgets
              .filter((widget) => widget.show === true)
              .sort((a, b) => a.id - b.id);

            let last_y = 10;

            SuccessLoad.widgets.forEach((wg) => {
              if (wg.type === "Chart") {
                wg.size.h = 380;
              } else if (wg.type === "ValueDisplay") {
                wg.size.h = 140;
              } else {
                wg.size.h = 200;
              }

              wg.size.w = window.innerWidth - 40;
              wg.size.x = 20;
              wg.size.y = last_y;
              last_y += wg.size.h + 12;
            });
          } else {
            state.webtype = "PC";
          }

          state.devices = SuccessLoad.devices;
          state.widgets = SuccessLoad.widgets;
          state.pages = SuccessLoad.pages;
          state.pageId = SuccessLoad.pageId;
          state.mqttUrl = normalizeMqttUrl(SuccessLoad.mqttUrl);
          state.style = SuccessLoad.style;

          await dispatch("fetchChannels", state.user.token);

          // เก็บเฉพาะ widget ที่ยังแสดงอยู่
          state.widgets = SuccessLoad.widgets.filter(
            (widget) => widget.show === true,
          );

          // เรียงตาม id เดิมที่บันทึกไว้ ห้าม reindex ทับ
          state.widgets.sort((a, b) => a.id - b.id);
          console.log(state.widgets);
        } else {
          console.log("False"),
            (state.devices = []),
            (state.widgets = []),
            (state.pages = [{ id: 0, name: "page", show: true }]),
            (state.pageId = 0),
            (state.mqttUrl = getDefaultMqttUrl());
        }
      } else {
        state.webtype = "PC";
        (state.devices = []),
          (state.widgets = []),
          (state.pages = [{ id: 0, name: "page", show: true }]),
          (state.pageId = 0),
          (state.mqttUrl = getDefaultMqttUrl());
      }
    },
    async channelupdate({ dispatch, state }) {
      return dispatch("fetchChannels", state.user && state.user.token);
    },
  },
  modules: {},
});
